<template>
  <div class="accordion-with-image__item" v-if="fields && fields.title" :class="{ open: toggleOn }">
    <div class="accordion-with-image__item--title" @click="toggle">
      <sc-text tag="h4" v-if="fields && fields.title" :field="fields.title" />
      <span v-if="childCount && childCount > 0" class="count"
        >(<span>{{ childCount }}</span
        >)</span
      >
    </div>
    <div class="accordion-with-image__item--content">
      <sc-placeholder name="jss-accordion-with-image-item-child" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Accordion-With-Image-Item',
  components: {
    ScText: Text,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  data: function () {
    return {
      toggleOn: false
    };
  },
  withPlaceholder() {
    return {
      placeholders: [
        {
          placeholder: 'jss-accordion-with-image-item-child',
          computedPropName: 'contentPlaceholder'
        }
      ]
    };
  },
  computed: {
    childCount() {
      return this.$options?.computed?.contentPlaceholder?.length;
    }
  },
  methods: {
    toggle() {
      this.toggleOn = !this.toggleOn;
    }
  }
};
</script>
